import styled from 'styled-components'

import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { WalletConnect } from 'components/Molecules/WalletManager/WalletConnect'
import { useUser } from 'hooks/user/useUser'
import { HeaderWallet } from 'components/Molecules/HeaderWallet'

export const WalletManager = () => {
  const { isProxy } = useUser('wallet')

  return (
    <WalletWrapper>
      <ContentSwitcherByState
        noWrapper
        activeState={isProxy ? 'connected' : 'disconnected'}
        stateObject={{
          disconnected: <WalletConnect />,
          connected: <HeaderWallet />,
        }}
      />
    </WalletWrapper>
  )
}

const WalletWrapper = styled.div`
  z-index: 1;
  ${({ theme }) => theme.breakPoints['1200px']} {
    display: flex;
    justify-content: center;
  }
`
